import apiCars from '../../api/apiCars'

const state = {
    brands: [],
    models: [],
    cars: {},
    currentPage: null,
    lastPage: null,
    firstPage: null,
    totalCars: null,
    previousGroupName: null,
    query: {
        user_id: null,
        brand: null,
        model: null,
        user_details: null,
        carGrade: null,
        chassis: [],
        lots: [],
        auctions: null,
        purchase_date: null,
        page: 1,
        order_column: 'lot_date',
        order_type: 'DESC',
        shipped_cars_from: null,
        shipped_cars_until: null,
        port_of_loading: null,
        parking_fee: false,
        exported_type: null,
        unpaid: false,
        year: null,
        vessel: null,
        country: null,
        manager: null,
        lot_date_from: null,
        lot_date_to: null,
        expected_exportation_from: null,
        expected_exportation_to: null,
        invoice_number: null,
        shipping_group_id: null,
        section: 5,
        show_rows: 50
    },
    carAlertMessage: null,
    carAlertModalStatus: false,
    carObj: null,
    triggerType: null,
    isResponse: false,
    groupIds: [],
    createMultiProformaModal: false,

}

const getters = {
    getCars: (state) => {
        return state.cars
    },
    getTotalsCarsNumber: (state) => {
        return state.totalCars
    },
    getCurrentCarsPage: (state) => {
        return state.currentPage
    },
    getLastCarsPage: (state) => {
        return state.lastPage
    },
    isLastCarsPage: (state) => {
        return state.currentPage === state.lastPage
    },
    getCarsQuery: (state) => {
        return state.query
    },
    getCarsOrderColumn: (state) => {
        return state.query.order_column
    },
    getCarsOrderType: (state) => {
        return state.query.order_type
    },
    getCarPreviousGroupName: (state) => {
        return state.previousGroupName
    },
    getCarsFirstPage: (state) => {
        return state.firstPage
    },
    getCarAlertMessage: (state) => {
        return state.carAlertMessage;
    },
    getCarAlertModalStatus: (state) => {
        return state.carAlertModalStatus;
    },
    getCarObj: (state) => {
        return state.carObj;
    },
    getTriggerType: (state) => {
        return state.triggerType;
    },
    isResponse: (state) => {
        return state.isResponse;
    },
    getGroupIds: (state) => {
        return state.groupIds;
    },
    getCreateMultiProformaModal: (state) => {
        return state.createMultiProformaModal;
    }
}

const mutations = {
    setCarsOrderColumn: (state, newValue) => {
        state.query.order_column = newValue
    },
    setTotalCarsNumber: (state, newValue) => {
        state.totalCars = newValue
    },
    setCarsOrderType: (state, newValue) => {
        state.query.order_type = newValue
    },
    setCars: (state, newCars) => {
        state.cars = newCars
    },
    setCurrentCarsPage: (state, pageNumber) => {
        state.currentPage = pageNumber
        state.query.page = pageNumber
    },
    setLastCarsPage: (state, pageNumber) => {
        state.lastPage = pageNumber
    },
    setFirstCarsPage: (state, pageNumber) => {
        state.firstPage = pageNumber
    },
    updateCars: (state, newCars) => {
        state.cars = newCars
    },
    setNewCarsQueryUserId: (state, newUser) => {
        state.query.user_id = newUser
    },
    setCarPreviousGroupName: (state, newValue) => {
        state.previousGroupName = newValue
    },
    updateCarsQueryFieldValue: (state, value) => {
        state.query[value.field] = value.value
    },
    setDefaultCarsQuery: (state) => {
        const defaultQ = {
            user_id: null,
            brand: null,
            model: null,
            user_details: null,
            carGrade: null,
            chassis: [],
            lots: [],
            auctions: null,
            purchase_date: null,
            page: 1,
            order_column: 'lot_date',
            order_type: 'DESC',
            shipped_cars_from: null,
            port_of_loading: null,
            parking_fee: false,
            exported_type: null,
            unpaid: false,
            year: null,
            vessel: null,
            country: null,
            manager: null,
            lot_date_from: null,
            lot_date_to: null,
            expected_exportation_from: null,
            expected_exportation_to: null,
            invoice_number: null,
            shipping_group_id: null,
            section: 5,
            show_rows: 50
        }
        state.query = Object.assign({}, defaultQ)
    },
    setCarAlertDetails: (state, details) => {
        state.carAlertMessage = details.carAlertMessage;
        state.carAlertModalStatus = details.carAlertModalStatus;
        state.carObj = details.carObj;
        state.triggerType = details.triggerType;
        if(details.isResponse !== undefined) {
            state.isResponse = details.isResponse;
        }
    },
    setShippingGroupIds: (state, groupId) => {
        state.groupIds.push(groupId)
    },
    removeShippingGroupId: (state, groupId) => {
        state.groupIds = state.groupIds.filter(m => m !== groupId)
    },
    removeAllShippingGroupIds: (state, groupId) => {
        state.groupIds = []
    },
    setCreateMultiProformaModal: (state, status) => {
        state.createMultiProformaModal = status
    }
}

const actions = {
    fetchCars: ({commit, dispatch, getters}) => {
        dispatch('setStatusLoading')
        apiCars
            .carsListRequest(getters.getCarsQuery)
            .then((response) => {
                commit('setTotalCarsNumber', response.data.total)
                commit('setCars', response.data.data)
                commit('setCurrentCarsPage', response.data.current_page)
                commit('setLastCarsPage', response.data.last_page)
                commit('setFirstCarsPage', 1)
                dispatch('setStatusLoaded')
            })
    },
    // alternative way { commit, dispatch, getters } <- gets only these methods from context variable
    loadMoreCars: ({commit, getters, dispatch}, newPage) => {
        dispatch('setStatusLoading')
        commit('setCurrentCarsPage', newPage)
        apiCars
            .carsListRequest(getters.getCarsQuery)
            .then((response) => {
                commit('updateCars', response.data.data)
                commit('setCars', response.data.data)
                commit('setCurrentCarsPage', response.data.current_page)
                commit('setLastCarsPage', response.data.last_page)
                commit('setFirstCarsPage', 1)
                commit('setTotalCarsNumber', response.data.total)
                dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    clearCarsQuery: ({commit}) => {
        commit('setDefaultCarsQuery')
    },
    setCarsQueryFieldValue: ({commit}, value) => {
        commit('updateCarsQueryFieldValue', value)
    },
    setCarsNewOrderColumn: ({commit}, newValue) => {
        commit('setCarsOrderColumn', newValue)
    },
    setCarsNewOrderType: ({commit}, newValue) => {
        commit('setCarsOrderType', newValue)
    },
    updateCarsQueryUserId: ({commit}, newValue) => {
        commit('setNewCarsQueryUserId', newValue)
    },
    fetchCarsWithSearchQuery: (context) => {
        context.dispatch('setStatusLoading');
        apiCars
            .carsListRequest(context.getters.getCarsQuery)
            .then((response) => {
                context.commit('setTotalCarsNumber', response.data.total)
                context.commit('setCars', response.data.data)
                context.commit('setCurrentCarsPage', response.data.current_page)
                context.commit('setLastCarsPage', response.data.last_page)
                context.dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    fetchCarsExcelWithSearchQuery: (context) => {
        apiCars
            .carsExportInExcelRequest(context.getters.getCarsQuery)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'cars.xlsx')
                document.body.appendChild(link)
                link.click()
            })
            .catch(error => console.log(error))
    },
    fetchCarsRecFeeExcel: (context) => {
        apiCars
            .carsRecFeeExportInExcelRequest(context.getters.getCarsQuery)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'rec_fee.xlsx')
                document.body.appendChild(link)
                link.click()
            })
            .catch(error => console.log(error))
    },
    updateCarPreviousGroupName: ({commit}, newValue) => {
        commit('setCarPreviousGroupName', newValue)
    },
    triggerBill: ({commit}, carParams) => {
        apiCars
            .triggerZohoBillRequest(carParams)
            .then((response) => {
                if(response.data.error !== undefined){
                    commit('setCarAlertDetails', {carAlertMessage: response.data.error, carAlertModalStatus: true, carObj: getters.getCarObj, triggerType: getters.getTriggerType, isResponse: true})
                }else{
                    commit('setCarAlertDetails', {carAlertMessage: 'Successfully triggered bill to ZOHO', carAlertModalStatus: true, carObj: getters.getCarObj, triggerType: getters.getTriggerType, isResponse: true})
//                    this.$store.dispatch('fetchCars')
                }
                console.log(response);
            })
            .catch(error => console.log(error))
    },
    triggerInvoice: ({commit}, carParams) => {
        apiCars
            .triggerZohoInvoiceRequest(carParams)
            .then((response) => {
                if(response.data.error !== undefined){
                    commit('setCarAlertDetails', {carAlertMessage: response.data.error, carAlertModalStatus: true, carObj: getters.getCarObj, triggerType: getters.getTriggerType, isResponse: true})
                }else{
                    commit('setCarAlertDetails', {carAlertMessage: 'Successfully triggered invoice to ZOHO', carAlertModalStatus: true, carObj: getters.getCarObj, triggerType: getters.getTriggerType, isResponse: true})
//                    this.$store.dispatch('fetchCars')
                }
                console.log(response);
            })
            .catch(error => console.log(error))
    },
    setCarAlertDetails: ({commit}, details) => {
        commit('setCarAlertDetails', details)
    },
    setShippingGroupIds: ({commit}, groupId) => {
        commit('setShippingGroupIds', groupId)
    },
    removeShippingGroupId: ({commit}, groupId) => {
        commit('removeShippingGroupId', groupId)
    },
    removeAllShippingGroupIds: ({commit}, groupId) => {
        commit('removeAllShippingGroupIds', groupId)
    },
    setCreateMultiProformaModal: ({commit}, status) => {
        commit('setCreateMultiProformaModal', status)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cars.js